import { useChannelContext } from "client/components/channel"
import { BrandWatermark } from "client/components/main/BrandWatermark"
import { CommerceFeaturedProductButton } from "client/packages/commerce/components/CommerceFeaturedProductButton"
import { TargetFeaturedProductButton } from "client/packages/target/components/TargetFeaturedProductButton"
import { useGlobalContext } from "client/packages/utils/GlobalContext"
import {
  PluginButtonList,
  VodPluginButtonList,
} from "shared/components/PluginButtonList"

import { DesktopVideoControls } from "../ui/videoControls/DesktopVideoControls"
import { useDesktopControlsOverlay } from "../ui/videoControls/useDesktopControlsOverlay"

import { LightboxDismissButton } from "./LightboxDismissButton"
import { SubtitlePlaceholderArea } from "./SubtitlePlaceholderArea"
import { VideoBadge } from "./VideoBadge"
import { useVideoContext } from "./VideoContext"

import styles from "./DesktopVideoOverlayLayer.module.css"

export type DesktopVideoOverlayProps = {
  brandWatermark?: boolean
}

export const DesktopVideoOverlayLayer = ({
  brandWatermark = false,
}: DesktopVideoOverlayProps) => {
  const { isPlaying, subtitlesVisible, mutedPreview } = useVideoContext()
  const { recordingId, live } = useChannelContext()
  const {
    state: { lightboxContent },
  } = useGlobalContext()

  const shouldShowPlaybackUI = live && !mutedPreview

  const {
    showControlsOverlay,
    pointerDetectionAreaRef,
    ...pointerEventHandlers
  } = useDesktopControlsOverlay({
    controlsEnabled: shouldShowPlaybackUI,
    isPlaying,
    hideDelayMs: 1500,
  })

  return (
    <div
      className={styles.mainContainer}
      ref={pointerDetectionAreaRef}
      {...pointerEventHandlers}
    >
      <div
        className={styles.desktopFadeInBackground}
        data-show-controls-overlay={showControlsOverlay}
      />
      <div className={styles.topSection}>
        <div className={styles.topLeftSection}>
          <div className={styles.topRow}>
            <div className={styles.topLeftRow}>
              <VideoBadge />
            </div>
            <div className={styles.topRightRow}>
              {lightboxContent.contentType !== "none" && (
                <LightboxDismissButton />
              )}
            </div>
          </div>
          {shouldShowPlaybackUI && <CommerceFeaturedProductButton />}
          {shouldShowPlaybackUI && <TargetFeaturedProductButton />}
        </div>
      </div>
      {shouldShowPlaybackUI && (
        <div className={styles.bottomSection}>
          {subtitlesVisible && <SubtitlePlaceholderArea />}
          <div className={styles.bottomRow}>
            <div
              className={styles.controlsContainer}
              data-show-controls-overlay={showControlsOverlay}
            >
              <DesktopVideoControls />
            </div>
            <div className={styles.pluginButtonsContainer}>
              {recordingId ? (
                <VodPluginButtonList />
              ) : (
                <PluginButtonList />
              )}
            </div>
          </div>
        </div>
      )}
      {brandWatermark && live && (
        <div className={styles.brandWatermarkContainer}>
          <BrandWatermark />
        </div>
      )}
    </div>
  )
}
